const CSRF_COOKIE_NAME = 'csrf_token';
const CSRF_HEADER_NAME = 'X-CSRF-Token';

function readCookie(name: string) {
  if (typeof document === 'undefined') return '';
  const prefix = `${encodeURIComponent(name)}=`;
  return document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix))
    ?.slice(prefix.length) || '';
}

function isSameOriginUrl(input: RequestInfo | URL) {
  if (typeof window === 'undefined') return false;
  try {
    const rawUrl = typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.href
        : input.url;
    return new URL(rawUrl, window.location.origin).origin === window.location.origin;
  } catch (e) {
    return false;
  }
}

function requestMethod(input: RequestInfo | URL, init?: RequestInit) {
  const method = init?.method || (typeof Request !== 'undefined' && input instanceof Request ? input.method : 'GET');
  return String(method || 'GET').toUpperCase();
}

function isSafeMethod(method: string) {
  return method === 'GET' || method === 'HEAD' || method === 'OPTIONS' || method === 'TRACE';
}

export function csrfToken() {
  return decodeURIComponent(readCookie(CSRF_COOKIE_NAME));
}

export function csrfHeaders(initHeaders?: HeadersInit) {
  const headers = new Headers(initHeaders || {});
  const token = csrfToken();
  if (token && !headers.has(CSRF_HEADER_NAME)) headers.set(CSRF_HEADER_NAME, token);
  return headers;
}

export function csrfHeaderObject(initHeaders: Record<string, string> = {}) {
  const token = csrfToken();
  return token && !Object.keys(initHeaders).some((name) => name.toLowerCase() === CSRF_HEADER_NAME.toLowerCase())
    ? { ...initHeaders, [CSRF_HEADER_NAME]: token }
    : initHeaders;
}

export function installCsrfFetch() {
  if (typeof window === 'undefined') return;
  const win = window as typeof window & { __frontV2CsrfFetchInstalled?: boolean };
  if (win.__frontV2CsrfFetchInstalled) return;
  win.__frontV2CsrfFetchInstalled = true;

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const method = requestMethod(input, init);
    if (isSafeMethod(method) || !isSameOriginUrl(input)) return nativeFetch(input, init);

    const headers = csrfHeaders(init?.headers || (typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined));
    return nativeFetch(input, { ...init, headers });
  };
}
